module.exports = __webpack_public_path__ + "static/assets/6badcaaefd39b380cb5373d917af2a1d.svg";